import { createSelector } from '@reduxjs/toolkit';
import { selectSitePricingCheckoutDelegateMetaById } from '../../../checkoutDetails';
import { RootState } from '../../../../../../../store/store';
import { PricingRegion } from '../../types';
import { selectLeadGenStateOptions } from '../../../../../../../store/features/leadGen';

export const selectDelegateRegionOptions = createSelector(
  [
    selectSitePricingCheckoutDelegateMetaById,
    selectLeadGenStateOptions,
    (state: RootState, delegateId: string, country: string) => country,
  ],
  (meta, leadGenStateOptions, country) => {
    if (leadGenStateOptions) {
      const lgRegions = leadGenStateOptions.find(
        (region: PricingRegion) => region.id === country,
      );
      return lgRegions?.options ?? [];
    }

    const regions = meta.regions || [];
    const foundRegion = regions.find((region) => region.id === country);

    return foundRegion?.options || [];
  },
);
